/**
 * How a restaurant is identified in ops lists: `"{name} - {city}"`. Several
 * restaurants share a name across cities, so the city is what tells them apart.
 * Falls back to the name alone when the city is unknown.
 */
export const formatRestaurantLabel = (name: string, city?: string | null) =>
  city ? `${name} - ${city}` : name;
